module.exports = __webpack_public_path__ + "static/media/GEM-dawn.a822ae5d.jpeg";